import * as actionTypes from '../actions/actionTypes'

const initialState = {
  documents: {
    documents: [],
    isLoading: false,
    isError: false
  },
  isLoading: false,
  isError: false
}

const documentReducer = (state = initialState, action = {}) => {
  const newState = { ...state }

  switch (action.type) {
    case actionTypes.FETCH_DOCUMENTS:
      return { ...newState, documents: { ...newState.documents, isLoading: true } }

    case actionTypes.FETCH_DOCUMENTS_SUCCESS:
      return { ...newState, documents: { documents: [...action.payload], isLoading: false, isError: false } }

    case actionTypes.FETCH_DOCUMENTS_FAILURE:
      return { ...newState, isLoading: false, isError: true }

    default:
      return { ...newState }
  }
}

export default documentReducer
